module.exports = __webpack_public_path__ + "static/media/icon.e326e80b.svg";